const API_BASE_URL = "https://loansmoney.in/partnerApi/public/";

export default API_BASE_URL;

    // "homepage": "https://loansmoney.in/main_dev",